import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import SmoothScroll from "@/components/site/SmoothScroll";
import { getLenis } from "@/lib/lenis";
import { isAppMode } from "@/lib/appMode";

export const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const appMode = isAppMode();
  useEffect(() => {
    const lenis = getLenis();
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (appMode) document.documentElement.classList.add("app-mode");
    return () => document.documentElement.classList.remove("app-mode");
  }, [appMode]);

  return (
    <SmoothScroll>
      {!appMode && <div className="noise-overlay" />}
      {!appMode && <Nav />}
      <main className="min-h-screen">{children}</main>
      {!appMode && <Footer />}
    </SmoothScroll>
  );
};
